import { Path, Svg, SvgProps } from 'react-native-svg'

export default function EsFlag(props: SvgProps) {
  return (
    <Svg width="60" height="40" viewBox="0 0 60 40" fill="none" {...props}>
      <Path d="M60 30H0V40H60V30Z" fill="#C60B1E" />
      <Path d="M60 10H0V30H60V10Z" fill="#FFC400" />
      <Path d="M60 0H0V10H60V0Z" fill="#C60B1E" />
    </Svg>
  )
}
